import { useKnockFeed as v } from "@knocklabs/react-core";
import o, { useEffect as y } from "react";
import { usePopper as _ } from "react-popper";
import E from "../../../core/hooks/useComponentVisible.mjs";
import { NotificationFeed as F } from "../NotificationFeed/NotificationFeed.mjs";
import "../NotificationFeed/NotificationFeedHeader.mjs";
/* empty css                              */
/* empty css            */
const N = ({
  store: e,
  feedClient: t
}) => {
  e.metadata.unseen_count > 0 && t.markAllAsSeen();
}, S = ({
  isVisible: e,
  onOpen: t = N,
  onClose: f,
  buttonRef: p,
  closeOnClickOutside: a = !0,
  placement: c = "bottom-end",
  ...m
}) => {
  const {
    colorMode: s,
    feedClient: r,
    useFeedStore: d
  } = v(), n = d(), {
    ref: i
  } = E(e, f, {
    closeOnClickOutside: a
  }), {
    styles: l,
    attributes: u
  } = _(p.current, i.current, {
    strategy: "fixed",
    placement: c,
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 8]
      }
    }]
  });
  return y(() => {
    e && t && t({
      store: n,
      feedClient: r
    });
  }, [e, t, n, r]), /* @__PURE__ */ o.createElement("div", { className: `rnf-notification-feed-popover rnf-notification-feed-popover--${s}`, style: {
    ...l.popper,
    visibility: e ? "visible" : "hidden",
    opacity: e ? 1 : 0
  }, ref: i, ...u.popper, role: "dialog", tabIndex: -1 }, /* @__PURE__ */ o.createElement("div", { className: "rnf-notification-feed-popover__inner" }, /* @__PURE__ */ o.createElement(F, { ...m })));
};
export {
  S as NotificationFeedPopover
};
//# sourceMappingURL=NotificationFeedPopover.mjs.map
